import { createIcon } from "@chakra-ui/icons";

// Created from plus.svg

export const PlusIcon = createIcon({
  displayName: "Plus",
  viewBox: "0 0 17 17",
  path: (
    <g>
      <path
        d="M8.36415 1.00011V15.7284"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 8.36426H15.7283"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});
